export default import.meta.ROLLDOWN_FILE_URL_y2CyI4lH8Co64RWy_ES3gQ